import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlSerializer, UrlTree } from '@angular/router';
import { AuthService } from '@core/services';
import { AppService } from '@core/services/app.service';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {

    constructor(
        private authService: AuthService,
        private appService: AppService,
        private router: Router,
        private urlSerializer: UrlSerializer,
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (!this.authService.isAccessTokenExpired()) {
            return true;
        }
        this.authService.setLoginRedirect(state.url);
        return this.router.createUrlTree(['/login']);
    }

    canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (!this.authService.isAccessTokenExpired()) {
            return true;
        }

        this.authService.setLoginRedirect(state.url);
        return this.router.createUrlTree(['/login']);
    }

    canLoad(_route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
        if (!this.authService.isAccessTokenExpired()) {
            return of(true);
        }
        const tree = this.router.createUrlTree(
            segments.map(segment => segment.path), 
            { queryParams: this.router.getCurrentNavigation()?.extractedUrl.queryParams},
        );
        this.authService.setLoginRedirect(this.urlSerializer.serialize(tree));
        return of(this.router.createUrlTree(['/login']));
    }
}
